/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogAddressDetailInfo = {
    ADDR: string;
    ADDRT: ZerogAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    BLVAL: string;
    BLP: string;
    TKNCNT: string;
    FTRXUT: number;
    LTRXUT: number;
    CCADDR: string;
    CTRXHA: string;
    SC: number;
    SMS: string;
};

export namespace ZerogAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

